import { Injectable } from '@angular/core';
import { ProductsService } from '@core/services/products.service';
import { IPreviewCard } from '../components/preview-card/IPreviewClass';
import { map, Observable, of } from 'rxjs';
import { Product } from '@core/models/piramide/Product';

@Injectable({
  providedIn: 'root',
})
export class BombPricesSectionService {
  private productsIds: number[] = [16051, 16941, 16850, 17082, 16243, 16240, 16213];
  constructor(private _productsService: ProductsService) {}
  public getBombPricesPreview(): Observable<IPreviewCard> {
    return of({
      id: 9999,
      title: 'Precios Bomba',
      class: 'brand',
      backgroundImages: [
        {
          tipo: 3,
          imagen: 'assets/img/seccion-bomb-prices/bomb-prices_secundaria.jpg',
        },
        {
          tipo: 2,
          imagen: 'assets/img/seccion-bomb-prices/bomb-prices_principal.jpg',
        },
      ],
    });
  }

  public getBombPricesProducts(): Observable<Product[]> {
    return this._productsService.products$.pipe(
      map((r) => {
        let products = r.filter((p) => this.productsIds.includes(p.id_producto));
        products.sort(
          (a, b) =>
            this.productsIds.indexOf(a.id_producto) - this.productsIds.indexOf(b.id_producto),
        );
        return products;
      }),
    );
  }
}
